import React from 'react';
import SafeIcon from '../common/SafeIcon';
import EduOpsLogo from './EduOpsLogo';

const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: 'FiGrid' },
  { id: 'demo', label: 'How It Works', icon: 'FiPlayCircle' },
  { id: 'students', label: 'Student Overview', icon: 'FiUsers' },
  { id: 'schedule', label: 'Class Schedule', icon: 'FiCalendar' },
  { id: 'attendance', label: 'Attendance Tiles', icon: 'FiCheckSquare' },
  { id: 'messages', label: 'Parent Messages', icon: 'FiMessageCircle' },
  { id: 'tasks', label: 'Staff Tasks', icon: 'FiCheckCircle' },
  { id: 'faq', label: 'FAQ & Support', icon: 'FiHelpCircle' },
];

export default function Sidebar({ activeTab, setActiveTab, isOpen, setIsOpen }) {
  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-slate-950/90 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar Container */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 glass-panel border-r border-y-0 border-l-0
        flex flex-col transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        {/* Logo Area */}
        <div className="h-20 flex items-center px-6 border-b border-slate-800/50">
          <div className="flex items-center gap-3">
            <EduOpsLogo size="md" />
            <span className="text-xl font-bold tracking-tight text-chalk">Edu<span className="text-principal">Ops</span></span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 py-8 space-y-1.5 overflow-y-auto custom-scrollbar">
          <div className="text-[10px] font-bold text-slate-600 uppercase tracking-[0.2em] mb-4 px-3">System Modules</div>
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => { setActiveTab(item.id); setIsOpen(false); }}
              className={`
                w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-all duration-300 group
                ${activeTab === item.id 
                  ? 'bg-blue-500/10 text-principal border border-blue-500/20 shadow-[0_0_15px_rgba(59,130,246,0.1)]' 
                  : 'text-slate-500 hover:bg-slate-800/40 hover:text-slate-200 border border-transparent'}
              `}
            >
              <SafeIcon 
                icon={item.icon} 
                className={`text-lg transition-transform group-hover:scale-110 ${activeTab === item.id ? 'text-principal' : 'text-slate-600 group-hover:text-slate-400'}`} 
              />
              <span className="font-semibold text-sm tracking-wide">{item.label}</span>
              
              {item.id === 'messages' && (
                <span className="ml-auto bg-bell text-white text-[10px] font-bold px-2 py-0.5 rounded-lg shadow-lg shadow-orange-500/20">2</span>
              )}
            </button>
          ))}
        </nav>

        {/* Bottom Settings */}
        <div className="p-4 border-t border-slate-800/50 bg-slate-950/20">
          <button className="w-full flex items-center gap-3 px-3 py-3 rounded-xl text-slate-500 hover:bg-slate-800/50 hover:text-slate-200 transition-all duration-200">
            <SafeIcon icon="FiSettings" className="text-lg" />
            <span className="font-semibold text-sm">Ops Settings</span>
          </button>
          
          <div className="mt-4 p-3 rounded-xl bg-slate-900 border border-slate-800">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
              <span className="text-[10px] font-mono text-slate-500 uppercase">Cloud Sync</span>
            </div>
            <div className="h-1 w-full bg-slate-800 rounded-full overflow-hidden">
              <div className="h-full bg-blue-500 w-3/4 rounded-full" />
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}